import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=d4df4f72&"
import script from "./Lottery.vue?vue&type=script&lang=js&"
export * from "./Lottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports